import { render, staticRenderFns } from "./RegistrationSupplierComponent.vue?vue&type=template&id=1c56f8de&scoped=true&"
import script from "./RegistrationSupplierComponent.vue?vue&type=script&lang=js&"
export * from "./RegistrationSupplierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56f8de",
  null
  
)

export default component.exports